const STUDENT_CPF_KEY = 'cpe-student-cpf'

const setStudentCpf = cpf => {
  try {
    window.sessionStorage.setItem(STUDENT_CPF_KEY, cpf)
  } catch {}
}

const getStudentCpf = () => {
  try {
    return window.sessionStorage.getItem(STUDENT_CPF_KEY) || ''
  } catch {
    return ''
  }
}

const clearStudentCpf = () => {
  try {
    window.sessionStorage.removeItem(STUDENT_CPF_KEY)
  } catch {}
}

const studentCpfStorage = { setStudentCpf, getStudentCpf, clearStudentCpf }
export default studentCpfStorage
